/* WTF drawer Check out, faster (R545, 2026-10-09; Jeff: "It has to think hard when adding to cart and going to checkout").
   Stock path: the Check out button submits #CartDrawer-Form, which POSTs to /cart (saves quantities and the gift note), and Shopify then
   redirects to /checkout. This script skips the POST when it is certain that the cart on the server already holds everything on screen,
   and goes straight to /checkout. The checkout itself is untouched.
   It goes straight ONLY when ALL of these hold; any doubt leaves the stock POST to run, which saves every field itself:
     - no /cart/add, /cart/change, /cart/update, /cart/clear or /discount/ request is in flight (a pass-through fetch counter below)
     - the page has been open 3 s or more (requests started before this script loaded are not counted)
     - the item area is not loading (no quantity change running, no add running)
     - every quantity box shows the quantity the server rendered (no change waiting in the 300 ms debounce)
     - the gift note on screen is the saved note (window.WtfCartGift.isSaved from wtf-cart-gift.js)
     - the form holds no field other than updates[], attributes[Gift Message], note and checkout
     - no other submit listener cancelled the submit
   Either way the button shows a busy state at the tap. The Google Analytics wtf_checkout_tap listener (wtf-cart-links.js) is a capture
   click listener and is not affected. Nothing here sends a request of its own. */
(function () {
  'use strict';
  if (window.__wtfFastCheckout) return;
  window.__wtfFastCheckout = true;

  var FORM_ID = 'CartDrawer-Form';
  var BTN_ID = 'CartDrawer-Checkout';
  var ALLOWED = { 'updates[]': 1, 'attributes[Gift Message]': 1, 'note': 1, 'checkout': 1 };
  var MUTATING = /\/(cart\/(add|change|update|clear)|discount\/)/;
  var inflight = 0;
  var resetTimer = null;

  /* Pass-through counter. It returns the very promise fetch returned. Same arguments, same result, no change for any caller. */
  try {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input) {
        var p = nativeFetch.apply(window, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || String(input);
          if (MUTATING.test(String(url).split('?')[0])) {
            inflight++;
            var done = function () { inflight = Math.max(0, inflight - 1); };
            p.then(done, done);
          }
        } catch (e) { /* never block a request */ }
        return p;
      };
    }
  } catch (e) { /* no counter: quiet() answers false below */ inflight = 1e9; }

  function quiet(form) {
    if (inflight > 0) return false;
    if (window.performance && performance.now() < 3000) return false;
    var items = document.getElementById('CartDrawer-CartItems');
    if (!items || items.classList.contains('cart__items--disabled')) return false;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('wtf-pending')) return false;

    var els = form.elements, i, el;
    for (i = 0; i < els.length; i++) {
      el = els[i];
      if (!el.name || el.disabled) continue;
      if (el.type === 'button' || el.type === 'submit' || el.type === 'reset') continue; /* the - and + buttons and Check out itself send no data */
      if (!ALLOWED[el.name]) return false;
    }
    var qty = form.querySelectorAll('input[name="updates[]"]');
    if (!qty.length) return false;
    for (i = 0; i < qty.length; i++) {
      if (String(qty[i].value) !== String(qty[i].getAttribute('value'))) return false;
      if (qty[i].checkValidity && !qty[i].checkValidity()) return false;
    }
    var note = form.querySelector('[name="note"]');
    if (note && note.value !== note.defaultValue) return false;
    var gift = form.querySelector('[name="attributes[Gift Message]"]');
    if (gift && !(window.WtfCartGift && window.WtfCartGift.isSaved && window.WtfCartGift.isSaved())) return false;
    return true;
  }

  function setBusy(btn, on) {
    if (resetTimer) { window.clearTimeout(resetTimer); resetTimer = null; }
    btn.classList.toggle('wtf-co-busy', on);
    if (on) {
      btn.setAttribute('aria-busy', 'true');
      resetTimer = window.setTimeout(function () { setBusy(btn, false); }, 15000); /* navigation blocked: give the button back */
    } else {
      btn.removeAttribute('aria-busy');
    }
  }

  /* Bubble phase on document: form-level listeners run first, so a listener that took over the submit is respected. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== FORM_ID || e.defaultPrevented) return;
    if (e.submitter && e.submitter.id !== BTN_ID) return;
    var btn = document.getElementById(BTN_ID);
    if (!btn) return;
    setBusy(btn, true);
    var fast = false;
    try { fast = quiet(form); } catch (err) { fast = false; }
    if (!fast) return; /* stock path: the form POSTs to /cart */
    e.preventDefault();
    window.location.assign('/checkout');
  });

  /* Back button (page restored from the back/forward cache): the button must not stay busy. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var btn = document.getElementById(BTN_ID);
    if (btn) setBusy(btn, false);
  });
})();
